// Helper to detect media type from URL or mediaType field
export const getMediaElement = (art) => {
  const type = art.mediaType; // "image" | "video" | "audio" | "3d" | "other"
  const mediaSrc = art.media || art.img;
    console.log(art);
  if (type === "video") {
    return (
      <video
        src={mediaSrc}
        poster={art.img}        // preview image as video thumbnail
        muted
        loop
        playsInline
        onMouseEnter={(e) => e.target.play()}
        onMouseLeave={(e) => { e.target.pause(); e.target.currentTime = 0; }}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    );
  }

  if (type === "audio") {
  return (
    <div style={{ position: "relative", width: "100%", height: "100%", overflow: "hidden" }}>
      
      {/* Preview image as background */}
      <img
        src={art.media}
        alt={art.name}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />

      {/* Darkened overlay so controls are readable */}
      <div style={{
        position: "absolute",
        inset: 0,
        background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.2) 50%, transparent 100%)",
      }} />

      {/* Audio badge top-left */}
      <div style={{
        position: "absolute",
        top: "8px",
        left: "8px",
        background: "rgba(0,0,0,0.6)",
        borderRadius: "999px",
        padding: "4px 10px",
        fontSize: "0.72rem",
        color: "white",
        backdropFilter: "blur(6px)",
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}>
        🎵 Audio NFT
      </div>

      {/* Playable audio anchored to bottom */}
      <audio
        src={art.img}
        controls
        style={{
          position: "absolute",
          bottom: "10px",
          left: "8px",
          right: "8px",
          width: "calc(100% - 16px)",
          height: "36px",
          borderRadius: "999px",
          // Chromium supports accent-color for the progress bar
          accentColor: "#22c55e",
        }}
        // Stop card click events (e.g. navigation) from firing when interacting with player
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}

  if (type === "3d") {
    return (
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <img
          src={art.img}
          alt={art.name}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        <div style={{
          position: "absolute",
          bottom: "8px",
          left: "8px",
          background: "rgba(0,0,0,0.7)",
          borderRadius: "999px",
          padding: "4px 10px",
          fontSize: "0.72rem",
          color: "white",
          backdropFilter: "blur(6px)",
        }}>
          📦 3D Model
        </div>
      </div>
    );
  }

  // Default: image (or fallback)
  return (
    <img
      src={art.img || art.media}
      alt={art.name}
      style={{ width: "100%", height: "100%", objectFit: "cover" }}
    />
  );
};